<template>
  <router-view />
</template>

<script>
export default {
  name: 'WrDashboard'
};
</script>
